import React, { FunctionComponent } from 'react';
import { Typography, Avatar } from '@mui/material';
import { LightbulbIcon } from '../../../../assets/icons';
import useStyles from './HelpfulTips.styles';

interface IProps {
  title?: string;
  tips?: [];
  testid: string;
}

const HelpfulTips: FunctionComponent<IProps> = ({
  title,
  tips = [],
  testid,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography
        variant="h2"
        className={classes.title}
        data-testid={`${testid}__helpful-tips__title`}
      >
        <Avatar className={classes.avatar}>
          <LightbulbIcon />
        </Avatar>
        {title}
      </Typography>
      {tips.map((tip, idx) => (
        <Typography
          key={idx}
          className={classes.paragraph}
          data-testid={`${testid}__helpful-tips__tip-${idx + 1}`}
        >
          {tip}
        </Typography>
      ))}
       <Typography
        key="tooltip-explain_tip"
        className={classes.paragraph}
        component="div"
        data-testid={`${testid}__helpful-tips__tip-tooltip-explain_tip`}
      >
        Hover over the Helpful Tips icon{' '}
        <Avatar className={classes.avatarSmall}>
          <LightbulbIcon />
        </Avatar>{' '}
        throughout the calculator for additional tips.
      </Typography>
    </div>
  );
};

export default HelpfulTips;